// LVGL Mono theme approximation — black/white/grey, no primary colour

export function buildContext(_primary, _secondary) {
    const pretty = {
        bg_color:     '#000000',
        bg_opa:       255,
        border_color: '#ffffff',
        border_width: 2,
        text_color:   '#ffffff',
    };

    const btnStyle = {
        bg_color:     '#000000',
        bg_opa:       255,
        border_color: '#ffffff',
        border_width: 2,
        text_color:   '#ffffff',
        states: {
            checked:          { bg_color: '#ffffff' },
            pressed:          { bg_color: '#ffffff' },
            pressedChecked:   { bg_color: '#ffffff' },
            disabled:         { text_color: '#666666' },
            disabledChecked:  { bg_color: '#222222', text_color: '#666666' },
        },
    };

    return {
        pretty,
        btnStyle,
    };
}
